import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Navbar from "../../components/Navbar";
import ImageUploader from "../../components/ImageUploader";
import { API_servicios } from "../../config/apiConfig";
import "./css/NuevoEmpleo.css";
import { API_BASE_URL } from "../../config/apiConfig";

const NuevoServicioSocial = () => {
  const [nombre, setNombre] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [email, setEmail] = useState("");
  const [ubicacion, setUbicacion] = useState("");
  const [telefono, setTelefono] = useState("");
  const [horario, setHorario] = useState("");
  const [logoUrl, setLogoUrl] = useState(null);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const navigate = useNavigate();
  const { name } = useParams();

  useEffect(() => {
    const cargarDatos = async () => {
      if (!name) return;

      try {
        const res = await fetch(`${API_servicios}/${encodeURIComponent(name)}`);
        if (!res.ok) throw new Error("Servicio no encontrado");
        const servicio = await res.json();

        setNombre(servicio.nombre || "");
        setDescripcion(servicio.descripcion || "");
        setEmail(servicio.email || "");
        setUbicacion(servicio.ubicacion || "");
        setTelefono(servicio.telefono || "");
        setHorario(servicio.horario || "");
        setLogoUrl(servicio.logoUrl || null);
        setIsEditing(true);
      } catch (error) {
        console.error("Error al cargar servicio:", error);
        toast.error("Error al cargar el servicio");
      }
    };

    cargarDatos();
  }, [name]);

  const handleCrearServicio = async () => {
    if (!nombre || !email) {
      toast.error("Por favor, rellena todos los campos obligatorios (*)");
      return;
    }

    const body = {
      nombre: nombre,
      descripcion: descripcion,
      email: email || "",
      ubicacion: ubicacion || "",
      telefono: telefono || "",
      horario: horario || "",
    };

    // Always include logoUrl (null if no image, filename if image exists)
    body.logoUrl = logoUrl;


    try {
      const url = isEditing
        ? `${API_BASE_URL}/serviciosAyuntamiento/${encodeURIComponent(name)}`
        : `${API_BASE_URL}/serviciosAyuntamiento`;

      const method = isEditing ? "PUT" : "POST";

      const response = await fetch(url, {
        method: method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      const data = await response.json();
      if (!response.ok)
        throw new Error(data.message || "Error al guardar el servicio");

      toast.success(
        `Servicio ${isEditing ? "actualizado" : "creado"} correctamente`,
        {
          autoClose: 2000,
        }
      );
      setTimeout(() => navigate("/admin/social"), 2000);
    } catch (error) {
      console.error("Error al enviar el servicio:", error);
      toast.error("Hubo un error al guardar el servicio");
    }
  };

  const handleEliminarServicio = async () => {
    if (!isEditing || !name) return;

    if (
      !window.confirm("¿Estás seguro de que quieres eliminar este servicio?")
    ) {
      return;
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/serviciosAyuntamiento/${encodeURIComponent(name)}`,
        {
          method: "DELETE",
        }
      );

      if (!response.ok) throw new Error("Error al eliminar el servicio");

      toast.success("Servicio eliminado correctamente", {
        autoClose: 2000,
      });
      setTimeout(() => navigate("/admin/social"), 2000);
    } catch (error) {
      console.error("Error al eliminar el servicio:", error);
      toast.error("Hubo un error al eliminar el servicio");
    }
  };

  const handleCancelar = () => setMostrarModal(true);
  const handleSalir = () => navigate("/admin/social");

  return (
    <>
      <Navbar />

      <main className="main creacion-ofertas">
        <section className="cabecera between">
          <h1 className="titulo-user align-center">
            {isEditing ? "EDITAR SERVICIO SOCIAL" : "NUEVO SERVICIO SOCIAL"}
          </h1>
        </section>

        <section className="formulario-alta between">
          <div className="comple-recurso column gap-30 w-450">
            <div className="campo column">
              <label className="verde mayusculas">Nombre del servicio *</label>
              <input
                type="text"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                placeholder="Ej: Servicio de Asistencia Social"
                required
              />
            </div>

            <div className="campo column">
              <label className="verde mayusculas">Email de contacto *</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="contacto@servicio.com"
                required
              />
            </div>

            <div className="campo column">
              <label className="verde mayusculas">Teléfono</label>
              <input
                type="tel"
                value={telefono}
                onChange={(e) => setTelefono(e.target.value)}
                placeholder="959 123 456"
              />
            </div>

            <div className="campo column">
              <label className="verde mayusculas">Ubicación</label>
              <input
                type="text"
                value={ubicacion}
                onChange={(e) => setUbicacion(e.target.value)}
                placeholder="Calle Example, 123"
              />
            </div>

            <div className="campo column">
              <label className="verde mayusculas">Horario de atención</label>
              <input
                type="text"
                value={horario}
                onChange={(e) => setHorario(e.target.value)}
                placeholder="Lunes a Viernes de 9:00 a 14:00"
              />
            </div>

            <ImageUploader
              imageUrl={logoUrl}
              onImageChange={setLogoUrl}
              folder="servicios"
              label="Subir logo o imagen"
            />
          </div>

          <div className="info-recurso column gap-30">
            <div className="campo column sobre-mi">
              <label className="verde mayusculas">
                DESCRIPCIÓN DEL SERVICIO
              </label>
              <textarea
                placeholder="Describe el servicio, sus funciones y cómo puede ayudar a los ciudadanos..."
                value={descripcion}
                onChange={(e) => setDescripcion(e.target.value)}
                rows="10"
              />
            </div>
          </div>
        </section>

        {mostrarModal && (
          <div className="ventana-cancelar fondo-blanco">
            <div className="column">
              <p>
                {isEditing
                  ? "Si sales de esta página se perderán los cambios no guardados."
                  : "Si sales no se guardará el servicio."}{" "}
                ¿Estás seguro?
              </p>
              <div className="botones flex gap-20">
                <button className="fondo-rojo blanco" onClick={handleSalir}>
                  Salir
                </button>
                <button
                  className="seguir blanco fondo-verde"
                  onClick={() => setMostrarModal(false)}
                >
                  {isEditing ? "Seguir editando" : "Seguir"}
                </button>
              </div>
            </div>
          </div>
        )}

        <section className="botones flex-center">
          <button
            className="fondo-rojo mayusculas blanco"
            onClick={handleCancelar}
          >
            Cancelar
          </button>

          {isEditing && (
            <button
              className="fondo-rojo mayusculas blanco ml-10"
              onClick={handleEliminarServicio}
            >
              Eliminar servicio
            </button>
          )}

          <button
            className="descargar mayusculas fondo-verde blanco"
            onClick={handleCrearServicio}
          >
            {isEditing ? "Guardar cambios" : "Crear nuevo servicio"}
          </button>
        </section>
      </main>
    </>
  );
};

export default NuevoServicioSocial;
